<template>
  <v-container
    class="pa-0"
    fluid
  >
    <v-row>
      <v-col
        class="text-end mt-4"
      >
        <v-btn
          color="primary"
          outlined
          @click="open"
        >
          <v-icon
            small
            class="mr-1"
          >
            fas fa-plus
          </v-icon>
          New Curtainwall Type
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-0">
        <v-card
          elevation="0"
          outlined
        >
          <v-data-table
            :headers="headers"
            :items="items"
            :footer-props="footer"
            :items-per-page="20"
            :search="search"
            :loading="loading"
            dense
          >
            <template #[`item.name`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.name }}
              </text-highlight>
            </template>
            <template #[`item.weight`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.weight }}
              </text-highlight>
            </template>
            <template #[`item.actions`]="{ item }">
              <v-btn
                class="ml-1 mt-1 mb-1"
                color="primary"
                outlined
                small
                @click="openEdit(item.id)"
              >
                EDIT
              </v-btn>
              <v-btn
                class="ml-1 mt-1 mb-1"
                color="error"
                outlined
                small
                @click="softDelete(item.id)"
              >
                DELETE
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <finished-good-commercial-type-form ref="finishedGoodCommercialTypeForm" @success="getCommercialTypes"/>
    <confirm-form ref="confirmForm" />
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import FinishedGoodCommercialTypeForm from '@/components/forms/finishedGoodCommercials/FinishedGoodCommercialTypeForm.vue';

export default {
  components: {
    FinishedGoodCommercialTypeForm
  },
  data: () => ({
    items: [],
    inventoryClassId: null,
    headers: [
      { text: 'Name', value: 'name' },
      { text: 'Weight Ratio (kg/sqft)', value: 'weight_ratio' },
      { text: 'Actions', value: 'actions', align: 'end' },
    ],
    footer: {
      'items-per-page-options': [10, 20, 50, 100, 500, 1000, -1],
    },
    loading: false,
  }),
  computed: {
    ...mapState({
      search: (state) => state.search,
    }),
  },
  watch: {
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.getCommercialTypes();
    },

    async getCommercialTypes() {
      this.loading = true;
      const submitModel = {
        filters: {}
      }
      this.items = await this.$api.finishedGoodCommercialType.read(submitModel);
      this.loading = false;
    },

    async softDelete(id) {
      const confirm = await this.$refs.confirmForm.open({
        title: 'Are you sure that you want to delete this record?',
      });
      if (!confirm) return;
      if (!id) return;

      const res = await this.$api.finishedGoodCommercialType.delete(id);

      if (!res) {
        this.$bus.$emit('showError');
        return;
      }
      this.$bus.$emit('showSuccess');
      this.getCommercialTypes();
    },

    open() {
      this.$refs.finishedGoodCommercialTypeForm.open();
    },

    openEdit(id) {
      this.$refs.finishedGoodCommercialTypeForm.open(id);
    },

    // success() {
    //   this.$bus.$emit('showSuccess');
    //   this.getWindowTypes();
    // },
  },
};
</script>
